export default "__VITE_ASSET__BDNGinTB__"